export default __webpack_public_path__ + "static/media/ipad3.209b5856.png";